<template>
    <div class="footer-main-div">
        <div class="actions-div">
            <PrimeButton
                label="Cancel"
                @click="close"
                variant="secondary"
                class="p-btn-root_secondary"
            />
                
            <PrimeButton
                :disabled="!isOtpValid"
                @click="verifyOtp"
                :loading="isVerifyLoading"
                label="Verify & Add"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button';
import { usePersonStore } from '~/stores/person';
import { useVaultStore } from '~/stores/person/vault/vault';
import { ModalNames } from '~/types/modals';


const emit = defineEmits(['closeDialog']);

const dialogRef = getDialogRef(ModalNames.EMAIL_VERIFICATION);

const close = () => {
    dialogRef.value.close();
};

const personStore = usePersonStore();
const vaultStore = useVaultStore();

const props = defineProps({
    otpValue: {
        type: String,
        default: '',
    },
});

const isVerifyLoading = ref(false);

const isOtpValid = computed(() => {
    return props.otpValue && props.otpValue.length === 6;
});

const verifyOtp = async () => {
    const payload = {
        email: dialogRef.value.data.email,
        primary: false,
        code: props.otpValue,
    };

    isVerifyLoading.value = true;

    try {
        await personStore.verifyEmailOtp(payload);
        
        // If this came from an exposure, suppress the original exposure
        if (dialogRef.value.data?.fromExposure && dialogRef.value.data?.exposureData) {
            const exposureData = dialogRef.value.data.exposureData;
            const exposureType = exposureData.type || 'email';
            await vaultStore.updateExposure(true, exposureType, exposureData.value);
        }
        
        await vaultStore.updatePotentialExposures('email', payload.email, true);
        
        // Refresh the potential exposures to update the UI
        if (dialogRef.value.data?.fromExposure) {
            await vaultStore.fetchPotentialExposures();
        }
        
        dialogRef.value.close();
    } catch (error) {
        isVerifyLoading.value = false;
        console.error(error);
        return;
    }

    isVerifyLoading.value = false;
};
defineExpose({ verifyOtp });
</script>
<style lang="scss" scoped>
.footer-main-div {
    @apply flex flex-col justify-center items-end self-stretch pt-8;
}
.actions-div {
    @apply flex justify-end items-center gap-3 flex-1 px-6 pb-6 w-full;
}
</style>
